(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire7b1f"];
var parcelRegister = parcelRequire.register;
parcelRegister("5lcEo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $99d0b85ccc709b3c$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $9QXJt = parcelRequire("9QXJt");

var $2MgeJ = parcelRequire("2MgeJ");

var $gSxLb = parcelRequire("gSxLb");
var $bTBLz = parcelRequire("bTBLz");

var $5gQ0v = parcelRequire("5gQ0v");

var $iRANg = parcelRequire("iRANg");

var $9msyL = parcelRequire("9msyL");

var $7z3Sn = parcelRequire("7z3Sn");

var $bhAAH = parcelRequire("bhAAH");

var $ahcAq = parcelRequire("ahcAq");

var $epZoF = parcelRequire("epZoF");

const $99d0b85ccc709b3c$var$Header = ({ ot7_events: ot7_events })=>{
    const { pathname: pathname } = (0, $gSxLb.useLocation)();
    const standingsUrl = pathname.replace("/schedule", "/standings");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $7z3Sn.default), {
        tabs: [
            [
                "all",
                "All"
            ],
            ...ot7_events.map((e)=>[
                    (0, $275Aj.kebabCase)(e.slug),
                    e.title
                ])
        ],
        tabRoot: "/schedule",
        ctaText: "Standings",
        ctaUrl: "/standings"
    }, "Schedule");
};
const $99d0b85ccc709b3c$var$Schedule = ()=>{
    let { section: currentTab } = (0, $bTBLz.useParams)();
    const fetchEvents = (0, $ahcAq.default)({
        url: `${(0, $epZoF.Urls).RestApiBaseUrl}/ot7_events/v1/public`,
        key: "ot7_events"
    });
    const events = (0, $275Aj.sortBy)(fetchEvents?.result.read(), "starts_at");
    const fetchGames = (0, $ahcAq.default)({
        url: `${(0, $epZoF.Urls).RestApiBaseUrl}/ot7_games/v1/public?all=true`,
        key: "ot7_games"
    });
    const games = (0, $275Aj.sortBy)(fetchGames?.result.read(), "starts_at");
    // get all events with games in them
    const eventsWithGames = events.filter((e)=>games.find((g)=>g.ot7_event_id === e.id));
    // get events with games in the future, but include events within the past few days
    // so basically show scores for the past few days and then switch to current week as next event get closer
    const futureEventsWithGames = eventsWithGames.filter((e)=>(0, $9QXJt.DateTime).fromISO(e.starts_at).plus({
            days: 4
        }) >= (0, $9QXJt.DateTime).now());
    // get the next event
    const nextEventWithGames = (0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).orderBy(futureEventsWithGames, "starts_at", "asc").at(0);
    // get the last event
    const lastEventWithGames = eventsWithGames.at(-1);
    // if no tab is selected, redirect user to the current week
    if (!currentTab) {
        if (!nextEventWithGames && lastEventWithGames) // If no future/next event, then redirect to last event (with or without games)
        currentTab = lastEventWithGames.slug;
        else if (nextEventWithGames) // Otherwise redirect to the next event
        currentTab = nextEventWithGames.slug;
        else // Default to the all tab
        currentTab = "all";
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $9msyL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Schedule"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $bhAAH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($99d0b85ccc709b3c$var$Header, {
        ot7_events: eventsWithGames
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5gQ0v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $bhAAH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $iRANg.default), {
        showAll: true,
        multiColumn: false,
        event: currentTab
    })))));
};
var $99d0b85ccc709b3c$export$2e2bcd8739ae039 = $99d0b85ccc709b3c$var$Schedule;

});

})();
//# sourceMappingURL=Schedule.efd969fd.js.map
